import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {OrderM} from "../model/order.mobel";
import {PaymentM} from "../model/payment";
import {PurchaseM} from "../model/purchase.model";
import {Util} from "../util/util";

@Injectable()
export class StatementService {

  private order: OrderM = new OrderM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(searchStr: string, status: string, customer_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/statement/list?searchStr=${searchStr}&status=${status}&customer_id=${customer_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getOrderStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/statement/getStatusCount`, this.options).map(res => res.json());
  }

  getListByPurchaseId(id: number) {
    this.reloadToken()
    return this.http.get(`/api/statement/getListByPurchaseId/${id}`, this.options).map(res => res.json());
  }

  getListByReceiptId(id: number) {
    this.reloadToken()
    return this.http.get(`/api/statement/getListByReceiptId/${id}`, this.options).map(res => res.json());
  }

  cancelSettle(id: number) {
    this.reloadToken()
    return this.http.put(`/api/statement/cancelSettle/${id}`, {}, this.options).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/statement.service.ts